import {
    ReportFilter,
    ReportFilterOperator,
    ReportFilterState,
} from "../components/Reports/CustomReports/ReportFilterState";

export const getQueryParams = (filter: ReportFilterState) => {
    const params: Record<string, string> = {};

    for (const [key, filterItem] of Object.entries(filter)) {
        if (filterItem) {
            params[getQueryParamKey(key, filterItem)] = getQueryParamValue(filterItem);
        }
    }

    return params;
};

const getQueryParamKey = (key: string, filterItem: ReportFilter) => {
    if (filterItem.operator === ReportFilterOperator.EQ) {
        return key;
    }

    return `${key}[${filterItem.operator}]`;
};

const getQueryParamValue = (filterItem: ReportFilter) => {
    if (Array.isArray(filterItem.value)) {
        return filterItem.value.map((value) => (typeof value === "string" ? value.trim() : value)).join(",");
    }

    const value = String(filterItem.value);
    return value.trim();
};
